<template>
  <div class="grid grid-cols-1 md:grid-cols-1 lg:grid-cols-[0.2fr,1fr,0.2fr] xl:grid-cols-[0.5fr,1fr,0.5fr] md:p-4 i">
    <div></div>
    <div class="flex justify-between mb-5 rounded-t-lg">
      <RouterLink :to="{ name: 'index' }" class="flex self-center p-5 space-between">
        <img src="/assets/TourDot_kr.png" alt="Logo" class="wrap h-8 mr-3" />
      </RouterLink>

      <div v-if="route.name === 'index'" class="flex items-center gap-1 pr-2 md:gap-2 md:pr-5">
        <button
          class="flex items-center justify-center p-0 bg-transparent border-none cursor-pointer"
          @click="uiStore.togglePromoMode"
        >
          <img
            class="h-12 img-fluid store-link"
            :src="uiStore.isPromoMode ? tourOnImg : tourOffImg"
            :alt="uiStore.isPromoMode ? 'Tour ON' : 'Tour OFF'"
          />
        </button>

        <RouterLink :to="{ name: 'stores' }" class="font-semibold text-success">
          <img class="h-12 img-fluid store-link" src="/assets/managerBtn.png" alt="managers" />
        </RouterLink>

        <a href="https://apps.apple.com/kr/app/ooi/id6446302012" target="_blank" rel="noopener noreferrer">
          <img class="h-12 img-fluid store-link" alt="intro image" src="/assets/app_store.png" />
        </a>

        <a
          href="https://play.google.com/store/apps/details?id=com.overk.oi&pli=1"
          target="_blank"
          rel="noopener noreferrer"
        >
          <img class="h-12 img-fluid store-link" alt="intro image" src="/assets/play_store.png" />
        </a>
      </div>
    </div>
    <div></div>
  </div>
</template>

<script lang="ts">
import { useRoute } from 'vue-router'
import { useUiStore } from '../stores/useUiStore'
import tourOnImg from '../../assets/TourOn.png'
import tourOffImg from '../../assets/TourOff.png'

export default {
  name: 'HeaderComponent',
  setup() {
    const route = useRoute()
    const uiStore = useUiStore()

    return {
      route,
      uiStore,
      tourOnImg,
      tourOffImg,
    }
  },
}
</script>

<style scoped></style>
